export default "__VITE_ASSET__C_K65c$Q__"